import {VIDEO_FETCH_DATA_SUCCESS,VIDEO_HAVE_ERROR,VIDEO_ARE_LOADING } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function VideoAction(action, payload) {
    switch (action) {
        case VIDEO_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };
    
        case VIDEO_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };
    
        case VIDEO_FETCH_DATA_SUCCESS:
            return {
                type: action,
                Video: payload,
            };

        default:
            return;
    }
}

export function videoFetchData() {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(VideoAction(VIDEO_ARE_LOADING, true));
                Get(HttpService.video).then((result) => {
                    dispatch(VideoAction(VIDEO_FETCH_DATA_SUCCESS, result.data));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(VideoAction(VIDEO_HAVE_ERROR, true));
        }
    }
}
